<template>
    <div class="modal-window uts027 sec">
        <header class="modal-header">
            <div class="tit">{{$i18nUtil.trans("title.receiver.query","수신자 조회")}}</div>
            <button @click="$emit('close')" class="btn_close">닫기</button>
        </header>
        <div class="modal-content">
            <div class="scroll">
                <v-data-table
                    v-model="selected"
                    :headers="selectHeader"
                    :items="receiverList"
                    :items-per-page="itemsPerPage"
                    :page.sync="page"
                    hide-default-footer
                    class="tb-contents new">

                   <template v-slot:[`item.userName`]="{ item }">
                        {{$i18nUtil.getLanguage() === 'en' ? item.userNameEn:item.userName}}
                      <!-- <div style="width:100px;">
                      </div> -->
                    </template>
                    <template v-slot:[`item.employeeNo`]="{ item }" style="width:150px;">
                        {{item.employeeNo}} 
                      <!-- <div style="width:100px;">
                      </div> -->
                    </template>
                    <template v-slot:[`item.deptName`]="{ item }" style="width:100px;">
                        {{$i18nUtil.getLanguage() === 'en' ? item.deptNameEn:item.deptName}}                      
                      <!-- <div style="width:calc(100% - 200px);">
                      </div> -->
                    </template> 
                    
                    <template slot="no-data">
                        <div class="nodata-txt-noicon">
                            <v-alert :value="true">
                            </v-alert> 
                        </div>
                    </template>
                </v-data-table>
                <div class="pagination">
                    <v-pagination
                        v-model="page"
                        circle
                        :length="pageCount"
                        :total-visible="7"
                    ></v-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
 
import UserTooltip from "@/components/cowork/common/user/UserTooltip";

export default {
  components: {
    UserTooltip,
  },
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      error: false,
      /* tenantId */
      tenantId: localStorage.getItem("tenantId"),

      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      changeTableData: false,
      userInfo: {},
      sortBy: 'paperTitle',
      sortDesc: false,
      selected: [],
      receiverList:[],

      selectHeader : [
        { text: this.$i18nUtil.trans("entity.user.user","사용자"), align: 'center', value: 'userName', sortable: false, width:'150px'},
        { text: this.$i18nUtil.trans("entity.user.employeeNo","사번"), align: 'center', value: 'employeeNo', sortable: false, width:'150px'},
        { text: this.$i18nUtil.trans("entity.user.deptName.002","부서명"), align: 'center', value: 'deptName', sortable: false, width:'calc(100% - 300px)'},
      ],
    };
  },
  mounted() {
  },
  created() {
    this.getReceiverList();
  },
  watch:{
    page : function() {
      if(this.changeTableData != true){
        this.changeTableData = true;
      }
      window.scrollTo(0, 0);
    },
    // sortBy: {
    //   handler() {
    //     let obj = this;
    //     obj.page = 1;
    //     obj.pageCount = 0;
    //     // obj.todoUserList = [];
    //     if(obj.changeTableData != true) {
    //       obj.changeTableData = true;
    //     }
    //   }
    // },
    // sortDesc: {
    //   handler() {
    //     let obj = this;
    //     obj.page = 1;
    //     obj.pageCount = 0;
    //     // obj.todoUserList = [];
    //     if(obj.changeTableData != true) {
    //       obj.changeTableData = true;
    //     }
    //   }
    // },
    changeTableData: {
      handler() {
        let obj = this;
        if(obj.changeTableData == true) {
        setTimeout(() => {
          obj.changeTableData = false;
          obj.selected = [];
          obj.getReceiverList();
        }, 500);
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("modals", ["showToast", "showModal"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    getReceiverList() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/todo/getTodoReceiverList",
        method: "post",
        params:{
          todoMainId : obj.modalInfo.todoMainId,
          currentPage: obj.page,
          itemsPerPage: obj.itemsPerPage,
        }
      };
      obj
      .COWORK_REST_SIMPLE_ACTION(reqData)
      .then((res) => {
        obj.receiverList = res.result.receiverList;
        obj.pageCount = res.result.receiverListPageCount;
      });
    },
  },
};
</script>
<style scoped>
/* 지역스타일 (Vue 객체스타일) */
</style>
<style> /* 전역스타일은 사용하지 말아 주세요. (board.css 에 추가 후 퍼블에 요청해주세요) */ </style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/todo/popup/ReceiverList.vue